module.exports = __webpack_public_path__ + "img/Circle_X.a2257ce1.svg";